// extracted by mini-css-extract-plugin
export default {"mainWrapper":"customer-order-information_mainWrapper__72sBp","boxWrapper":"customer-order-information_boxWrapper__0Be2W","rowWrapper":"customer-order-information_rowWrapper__N0Thi"};